export default function FixedCTA() {
  const handleScrollToForm = () => {
    document.querySelector('#fiyat-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const whatsappLink = 'https://wa.me/905395851199?text=' + encodeURIComponent(
    'Merhaba, İlkim Butik Otel hakkında bilgi almak istiyorum. Fiyat ve müsaitlik bilgisi alabilir miyim?'
  );

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <div className="bg-background-50/95 backdrop-blur-md border-t border-background-200/60 px-4 py-3 flex items-center gap-3">
        <button
          onClick={handleScrollToForm}
          className="flex-1 px-4 py-3 bg-primary-500 text-background-50 rounded-xl font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-calendar-check-line mr-1.5" />
          Tarih Seç
        </button>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 px-4 py-3 bg-green-600 text-white rounded-xl font-semibold text-sm hover:bg-green-700 transition-colors whitespace-nowrap text-center cursor-pointer"
        >
          <i className="ri-whatsapp-line mr-1.5" />
          WhatsApp'tan Sor
        </a>
      </div>
    </div>
  );
}